import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Carousel } from 'antd';
import Button from '../../../../components/Button/Button';
import './Ad.scss';

export default ({ country, scope = 'lmi' }) => {
  const [covers, setCovers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCovers = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const response = await fetch('https://lmicdn.blob.core.windows.net/common/banners/rc_ads.json');

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        // Filter ads based on scope - show ads for "all" or "dashboard"
        const filteredAds = data.advertisements.filter((ad) => {
          const appliedApps = ad.applied_apps;
          return appliedApps?.includes('all') || appliedApps?.includes('rc');
        });
        setCovers(filteredAds);
      } catch (err) {
        console.error('Error fetching covers:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCovers();
  }, []);

  if (isLoading) {
    return (
      <div className="card">
        <div className="dashboard-ad-loading">
          <div className="spinner">Loading...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card">
        <div className="dashboard-ad-error">
          <p>Failed to load advertisements</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <Carousel effect="fade" autoplay autoplaySpeed={5000} dots={false}>
        {scope === 'lmi' &&
          covers
            .filter((item) => item.scope === scope)
            .map(
              (item) =>
                item.countries.includes(country) && (
                  <div key={item.key} className={classNames('dashboard-ad', { iprofile: scope === 'iprofile' })}>
                    <div className="dashboard-ad-cover" style={{ backgroundImage: `url(${item.cover})` }} />
                    <div className="dashboard-ad-overlay">
                      <h1>{item.title}</h1>
                      <h3>{item.description}</h3>
                      {item?.linkType && item.linkType === 'local' ? (
                        <Link to={item.link}>
                          <Button secondary block>
                            {item.button_text || 'Find out more'}
                          </Button>
                        </Link>
                      ) : (
                        <Button secondary block href={item.link} target="_blank">
                          {item.button_text || 'Find out more'}
                        </Button>
                      )}
                    </div>
                  </div>
                )
            )}
        {scope === 'iprofile' &&
          covers
            .filter((item) => item.scope === scope)
            .map((item) => (
              <div key={item.key} className={classNames('dashboard-ad', { iprofile: scope === 'iprofile' })}>
                <div className="dashboard-ad-cover" style={{ backgroundImage: `url(${item.cover})` }} />
                <div className="dashboard-ad-overlay">
                  <h1>{item.title}</h1>
                  <h2>{item.description}</h2>
                  {item?.linkType && item.linkType === 'local' ? (
                    <Link to={item.link}>
                      <Button secondary block>
                        {item.button_text || 'Find out more'}
                      </Button>
                    </Link>
                  ) : (
                    <Button className="action-button" block href={item.link} target="_blank">
                      {item.button_text || 'Find out more'}
                    </Button>
                  )}
                </div>
              </div>
            ))}
      </Carousel>
    </div>
  );
};
